// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistPricingPage-cls1_pxb","cls2":"CoScientistPricingPage-cls2_QKu CoScientistPricingPage-cls1_pxb"};